import { type ClaimAmount, type ClaimType, type Benefit, type Reason, CLAIM_STATUSES } from 'all-in-one-shared-api';
import { getLocaleDescription } from 'utils/getLocaleDescription';
import { getClaimType } from 'utils/claims';

export type ClaimHistoryResults = {
  patientName: string;
  claimId: string;
  treatmentDate: string;
  claimType: ClaimType;
  benefit: Benefit;
  receiptAmount: ClaimAmount;
  paidAmount?: paid;
  shortfallAmount?: ClaimAmount;
  reasons?: Reason[];
  paidDate?: string;
  claimStatus: string;
  paymentMethod?: string;
  paymentMethodChinese?: string;
};
export interface paid {
  amount?: string;
  currency?: string;
  des?: string;
}

export type ClaimHistoryData = {
  patientName?: string;
  claimId?: string;
  treatmentDate: string;
  claimTypeDescription: string;
  receiptAmount?: ClaimAmount;
  paidAmount?: paid;
  shortfallAmount?: ClaimAmount;
  reasons?: string;
  paidDate?: string;
  paymentMethod?: string;
  networkClaim?: string;
};

const formatClaimHistoryData =
  (isEnglish = true) =>
  ({
    claimType,
    benefit,
    reasons,
    claimStatus,
    paymentMethod,
    paymentMethodChinese,
    ...data
  }: Readonly<ClaimHistoryResults>): Readonly<ClaimHistoryData> => {
    return {
      ...data,
      claimTypeDescription: getLocaleDescription(isEnglish)(getClaimType(claimType, benefit)),
      reasons: reasons?.map((reason) => getLocaleDescription(isEnglish)(reason)).join(', ') ?? '',
      paymentMethod: claimStatus === CLAIM_STATUSES.DECLINED ? '' : isEnglish ? paymentMethod : paymentMethodChinese,
    };
  };

export default formatClaimHistoryData;
